import React from 'react'
import CSS from './MarkdownSection.module.scss'
import MarkdownRenderer from './MarkdownRenderer'

const MarkdownSection = ({ htmlAst, children }) => {
  return (
    <div className={CSS.root}>
      {htmlAst ? <MarkdownRenderer htmlAst={htmlAst} /> : null}
      {children ? children : null}
    </div>
  )
}

export default MarkdownSection
